// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"cef46286","70":"b9948bf3","131":"74d3dbf1","320":"04b08c0e","467":"a515b134","787":"94b4f5c3","823":"0debc582"}[chunkId] + ".chunk.js";
};